@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(-632_821_196)
internal val Res.drawable.sea_lantern: DrawableResource by lazy {
      DrawableResource("drawable:sea_lantern", setOf(
        ResourceItem(setOf(), "${MD}drawable/sea_lantern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-551_889_167)
internal val Res.drawable.sea_pickle: DrawableResource by lazy {
      DrawableResource("drawable:sea_pickle", setOf(
        ResourceItem(setOf(), "${MD}drawable/sea_pickle.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_046_896_841)
internal val Res.drawable.seagrass: DrawableResource by lazy {
      DrawableResource("drawable:seagrass", setOf(
        ResourceItem(setOf(), "${MD}drawable/seagrass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-589_140_374)
internal val Res.drawable.shears: DrawableResource by lazy {
      DrawableResource("drawable:shears", setOf(
        ResourceItem(setOf(), "${MD}drawable/shears.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_024_869_723)
internal val Res.drawable.sheep_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:sheep_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/sheep_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_145_297_391)
internal val Res.drawable.shield: DrawableResource by lazy {
      DrawableResource("drawable:shield", setOf(
        ResourceItem(setOf(), "${MD}drawable/shield.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_358_534_958)
internal val Res.drawable.shroomlight: DrawableResource by lazy {
      DrawableResource("drawable:shroomlight", setOf(
        ResourceItem(setOf(), "${MD}drawable/shroomlight.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_257_658_310)
internal val Res.drawable.shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_238_865_731)
internal val Res.drawable.shulker_shell: DrawableResource by lazy {
      DrawableResource("drawable:shulker_shell", setOf(
        ResourceItem(setOf(), "${MD}drawable/shulker_shell.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-122_209_652)
internal val Res.drawable.shulker_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:shulker_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/shulker_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-164_641_547)
internal val Res.drawable.silverfish_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:silverfish_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/silverfish_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_116_885_125)
internal val Res.drawable.skeleton_horse_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:skeleton_horse_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/skeleton_horse_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(437_721_955)
internal val Res.drawable.skeleton_skull: DrawableResource by lazy {
      DrawableResource("drawable:skeleton_skull", setOf(
        ResourceItem(setOf(), "${MD}drawable/skeleton_skull.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_141_337_486)
internal val Res.drawable.skeleton_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:skeleton_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/skeleton_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(602_574_756)
internal val Res.drawable.skull_banner_pattern: DrawableResource by lazy {
      DrawableResource("drawable:skull_banner_pattern", setOf(
        ResourceItem(setOf(), "${MD}drawable/skull_banner_pattern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(601_426_516)
internal val Res.drawable.slime_ball: DrawableResource by lazy {
      DrawableResource("drawable:slime_ball", setOf(
        ResourceItem(setOf(), "${MD}drawable/slime_ball.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-408_959_956)
internal val Res.drawable.slime_block: DrawableResource by lazy {
      DrawableResource("drawable:slime_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/slime_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-97_217_704)
internal val Res.drawable.slime_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:slime_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/slime_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_086_151_509)
internal val Res.drawable.smithing_table: DrawableResource by lazy {
      DrawableResource("drawable:smithing_table", setOf(
        ResourceItem(setOf(), "${MD}drawable/smithing_table.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(454_717_358)
internal val Res.drawable.smoker: DrawableResource by lazy {
      DrawableResource("drawable:smoker", setOf(
        ResourceItem(setOf(), "${MD}drawable/smoker.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_377_639_511)
internal val Res.drawable.smooth_quartz: DrawableResource by lazy {
      DrawableResource("drawable:smooth_quartz", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_quartz.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_760_036_061)
internal val Res.drawable.smooth_quartz_slab: DrawableResource by lazy {
      DrawableResource("drawable:smooth_quartz_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_quartz_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_210_819_019)
internal val Res.drawable.smooth_quartz_stairs: DrawableResource by lazy {
      DrawableResource("drawable:smooth_quartz_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_quartz_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_205_222_214)
internal val Res.drawable.smooth_red_sandstone: DrawableResource by lazy {
      DrawableResource("drawable:smooth_red_sandstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_red_sandstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_213_912_832)
internal val Res.drawable.smooth_red_sandstone_slab: DrawableResource by lazy {
      DrawableResource("drawable:smooth_red_sandstone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_red_sandstone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_071_763_619)
internal val Res.drawable.smooth_red_sandstone_stairs: DrawableResource by lazy {
      DrawableResource("drawable:smooth_red_sandstone_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_red_sandstone_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_743_703_535)
internal val Res.drawable.smooth_sandstone: DrawableResource by lazy {
      DrawableResource("drawable:smooth_sandstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_sandstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(260_223_464)
internal val Res.drawable.smooth_sandstone_slab: DrawableResource by lazy {
      DrawableResource("drawable:smooth_sandstone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_sandstone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_984_730_656)
internal val Res.drawable.smooth_sandstone_stairs: DrawableResource by lazy {
      DrawableResource("drawable:smooth_sandstone_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_sandstone_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(795_316_199)
internal val Res.drawable.smooth_stone: DrawableResource by lazy {
      DrawableResource("drawable:smooth_stone", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_stone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_098_513_984)
internal val Res.drawable.smooth_stone_slab: DrawableResource by lazy {
      DrawableResource("drawable:smooth_stone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/smooth_stone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_078_675_680)
internal val Res.drawable.snow: DrawableResource by lazy {
      DrawableResource("drawable:snow", setOf(
        ResourceItem(setOf(), "${MD}drawable/snow.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_600_789_198)
internal val Res.drawable.snow_block: DrawableResource by lazy {
      DrawableResource("drawable:snow_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/snow_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(770_880_085)
internal val Res.drawable.snowball: DrawableResource by lazy {
      DrawableResource("drawable:snowball", setOf(
        ResourceItem(setOf(), "${MD}drawable/snowball.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-128_899_135)
internal val Res.drawable.soul_campfire: DrawableResource by lazy {
      DrawableResource("drawable:soul_campfire", setOf(
        ResourceItem(setOf(), "${MD}drawable/soul_campfire.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_820_462_335)
internal val Res.drawable.soul_lantern: DrawableResource by lazy {
      DrawableResource("drawable:soul_lantern", setOf(
        ResourceItem(setOf(), "${MD}drawable/soul_lantern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(246_120_284)
internal val Res.drawable.soul_sand: DrawableResource by lazy {
      DrawableResource("drawable:soul_sand", setOf(
        ResourceItem(setOf(), "${MD}drawable/soul_sand.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(107_411_767)
internal val Res.drawable.soul_soil: DrawableResource by lazy {
      DrawableResource("drawable:soul_soil", setOf(
        ResourceItem(setOf(), "${MD}drawable/soul_soil.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_877_137_670)
internal val Res.drawable.soul_torch: DrawableResource by lazy {
      DrawableResource("drawable:soul_torch", setOf(
        ResourceItem(setOf(), "${MD}drawable/soul_torch.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_974_215_010)
internal val Res.drawable.spawner: DrawableResource by lazy {
      DrawableResource("drawable:spawner", setOf(
        ResourceItem(setOf(), "${MD}drawable/spawner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_139_118_954)
internal val Res.drawable.spectral_arrow: DrawableResource by lazy {
      DrawableResource("drawable:spectral_arrow", setOf(
        ResourceItem(setOf(), "${MD}drawable/spectral_arrow.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_078_485_712)
internal val Res.drawable.spider_eye: DrawableResource by lazy {
      DrawableResource("drawable:spider_eye", setOf(
        ResourceItem(setOf(), "${MD}drawable/spider_eye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-20_860_839)
internal val Res.drawable.spider_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:spider_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/spider_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_716_850_483)
internal val Res.drawable.splash_fire_res: DrawableResource by lazy {
      DrawableResource("drawable:splash_fire_res", setOf(
        ResourceItem(setOf(), "${MD}drawable/splash_fire_res.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-429_905_655)
internal val Res.drawable.splash_potion: DrawableResource by lazy {
      DrawableResource("drawable:splash_potion", setOf(
        ResourceItem(setOf(), "${MD}drawable/splash_potion.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(858_937_055)
internal val Res.drawable.sponge: DrawableResource by lazy {
      DrawableResource("drawable:sponge", setOf(
        ResourceItem(setOf(), "${MD}drawable/sponge.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-752_597_207)
internal val Res.drawable.spruce_boat: DrawableResource by lazy {
      DrawableResource("drawable:spruce_boat", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_boat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(836_449_616)
internal val Res.drawable.spruce_button: DrawableResource by lazy {
      DrawableResource("drawable:spruce_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-818_582_082)
internal val Res.drawable.spruce_door: DrawableResource by lazy {
      DrawableResource("drawable:spruce_door", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_door.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-898_936_757)
internal val Res.drawable.spruce_fence: DrawableResource by lazy {
      DrawableResource("drawable:spruce_fence", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_fence.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_457_835_340)
internal val Res.drawable.spruce_fence_gate: DrawableResource by lazy {
      DrawableResource("drawable:spruce_fence_gate", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_fence_gate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-210_541_769)
internal val Res.drawable.spruce_leaves: DrawableResource by lazy {
      DrawableResource("drawable:spruce_leaves", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_leaves.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(440_450_149)
internal val Res.drawable.spruce_log: DrawableResource by lazy {
      DrawableResource("drawable:spruce_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_795_595_418)
internal val Res.drawable.spruce_planks: DrawableResource by lazy {
      DrawableResource("drawable:spruce_planks", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_planks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(527_390_305)
internal val Res.drawable.spruce_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:spruce_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_104_718_511)
internal val Res.drawable.spruce_sapling: DrawableResource by lazy {
      DrawableResource("drawable:spruce_sapling", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_sapling.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(760_171_722)
internal val Res.drawable.spruce_sign: DrawableResource by lazy {
      DrawableResource("drawable:spruce_sign", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_sign.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(785_440_924)
internal val Res.drawable.spruce_slab: DrawableResource by lazy {
      DrawableResource("drawable:spruce_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_530_510_744)
internal val Res.drawable.spruce_stairs: DrawableResource by lazy {
      DrawableResource("drawable:spruce_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_486_097_210)
internal val Res.drawable.spruce_trapdoor: DrawableResource by lazy {
      DrawableResource("drawable:spruce_trapdoor", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_trapdoor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-296_297_428)
internal val Res.drawable.spruce_wood: DrawableResource by lazy {
      DrawableResource("drawable:spruce_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/spruce_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(128_402_007)
internal val Res.drawable.squid_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:squid_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/squid_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_036_618_158)
internal val Res.drawable.stick: DrawableResource by lazy {
      DrawableResource("drawable:stick", setOf(
        ResourceItem(setOf(), "${MD}drawable/stick.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_252_125_445)
internal val Res.drawable.sticky_piston: DrawableResource by lazy {
      DrawableResource("drawable:sticky_piston", setOf(
        ResourceItem(setOf(), "${MD}drawable/sticky_piston.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(14_633_294)
internal val Res.drawable.stone: DrawableResource by lazy {
      DrawableResource("drawable:stone", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-257_750_450)
internal val Res.drawable.stone_axe: DrawableResource by lazy {
      DrawableResource("drawable:stone_axe", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_axe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(59_474_585)
internal val Res.drawable.stone_brick_slab: DrawableResource by lazy {
      DrawableResource("drawable:stone_brick_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_brick_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-753_813_373)
internal val Res.drawable.stone_brick_stairs: DrawableResource by lazy {
      DrawableResource("drawable:stone_brick_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_brick_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(558_330_244)
internal val Res.drawable.stone_brick_wall: DrawableResource by lazy {
      DrawableResource("drawable:stone_brick_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_brick_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(715_264_633)
internal val Res.drawable.stone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:stone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(991_918_566)
internal val Res.drawable.stone_button: DrawableResource by lazy {
      DrawableResource("drawable:stone_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_954_112_188)
internal val Res.drawable.stone_hoe: DrawableResource by lazy {
      DrawableResource("drawable:stone_hoe", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_hoe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-511_780_309)
internal val Res.drawable.stone_pickaxe: DrawableResource by lazy {
      DrawableResource("drawable:stone_pickaxe", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_pickaxe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_044_445_983)
internal val Res.drawable.stone_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:stone_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-277_165_710)
internal val Res.drawable.stone_shovel: DrawableResource by lazy {
      DrawableResource("drawable:stone_shovel", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_shovel.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_689_142_671)
internal val Res.drawable.stone_slab: DrawableResource by lazy {
      DrawableResource("drawable:stone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(665_379_147)
internal val Res.drawable.stone_stairs: DrawableResource by lazy {
      DrawableResource("drawable:stone_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_700_382_766)
internal val Res.drawable.stone_sword: DrawableResource by lazy {
      DrawableResource("drawable:stone_sword", setOf(
        ResourceItem(setOf(), "${MD}drawable/stone_sword.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_098_814_308)
internal val Res.drawable.stonecutter: DrawableResource by lazy {
      DrawableResource("drawable:stonecutter", setOf(
        ResourceItem(setOf(), "${MD}drawable/stonecutter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(497_662_689)
internal val Res.drawable.stray_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:stray_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/stray_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(377_138_868)
internal val Res.drawable.strider_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:strider_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/strider_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-267_239_976)
internal val Res.drawable.string: DrawableResource by lazy {
      DrawableResource("drawable:string", setOf(
        ResourceItem(setOf(), "${MD}drawable/string.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(234_306_098)
internal val Res.drawable.stripped_acacia_log: DrawableResource by lazy {
      DrawableResource("drawable:stripped_acacia_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_acacia_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_596_015_391)
internal val Res.drawable.stripped_acacia_wood: DrawableResource by lazy {
      DrawableResource("drawable:stripped_acacia_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_acacia_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_797_770_239)
internal val Res.drawable.stripped_birch_log: DrawableResource by lazy {
      DrawableResource("drawable:stripped_birch_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_birch_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(551_436_258)
internal val Res.drawable.stripped_birch_wood: DrawableResource by lazy {
      DrawableResource("drawable:stripped_birch_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_birch_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_091_068_545)
internal val Res.drawable.stripped_crimson_hyphae: DrawableResource by lazy {
      DrawableResource("drawable:stripped_crimson_hyphae", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_crimson_hyphae.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_820_257_934)
internal val Res.drawable.stripped_crimson_stem: DrawableResource by lazy {
      DrawableResource("drawable:stripped_crimson_stem", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_crimson_stem.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_992_353_575)
internal val Res.drawable.stripped_dark_oak_log: DrawableResource by lazy {
      DrawableResource("drawable:stripped_dark_oak_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_dark_oak_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_410_899_092)
internal val Res.drawable.stripped_dark_oak_wood: DrawableResource by lazy {
      DrawableResource("drawable:stripped_dark_oak_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_dark_oak_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-524_508_000)
internal val Res.drawable.stripped_jungle_log: DrawableResource by lazy {
      DrawableResource("drawable:stripped_jungle_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_jungle_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_312_111_442)
internal val Res.drawable.stripped_jungle_wood: DrawableResource by lazy {
      DrawableResource("drawable:stripped_jungle_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_jungle_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_832_420_920)
internal val Res.drawable.stripped_oak_log: DrawableResource by lazy {
      DrawableResource("drawable:stripped_oak_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_oak_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-549_662_248)
internal val Res.drawable.stripped_oak_wood: DrawableResource by lazy {
      DrawableResource("drawable:stripped_oak_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_oak_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_620_538_060)
internal val Res.drawable.stripped_spruce_log: DrawableResource by lazy {
      DrawableResource("drawable:stripped_spruce_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_spruce_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-968_365_320)
internal val Res.drawable.stripped_spruce_wood: DrawableResource by lazy {
      DrawableResource("drawable:stripped_spruce_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_spruce_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(329_557_193)
internal val Res.drawable.stripped_warped_hyphae: DrawableResource by lazy {
      DrawableResource("drawable:stripped_warped_hyphae", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_warped_hyphae.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(643_710_813)
internal val Res.drawable.stripped_warped_stem: DrawableResource by lazy {
      DrawableResource("drawable:stripped_warped_stem", setOf(
        ResourceItem(setOf(), "${MD}drawable/stripped_warped_stem.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-509_720_930)
internal val Res.drawable.structure_block: DrawableResource by lazy {
      DrawableResource("drawable:structure_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/structure_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_542_405_905)
internal val Res.drawable.structure_void: DrawableResource by lazy {
      DrawableResource("drawable:structure_void", setOf(
        ResourceItem(setOf(), "${MD}drawable/structure_void.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable8Resources(map: MutableMap<String, DrawableResource>) {
  map.put("sea_lantern", Res.drawable.sea_lantern)
  map.put("sea_pickle", Res.drawable.sea_pickle)
  map.put("seagrass", Res.drawable.seagrass)
  map.put("shears", Res.drawable.shears)
  map.put("sheep_spawn_egg", Res.drawable.sheep_spawn_egg)
  map.put("shield", Res.drawable.shield)
  map.put("shroomlight", Res.drawable.shroomlight)
  map.put("shulker_box", Res.drawable.shulker_box)
  map.put("shulker_shell", Res.drawable.shulker_shell)
  map.put("shulker_spawn_egg", Res.drawable.shulker_spawn_egg)
  map.put("silverfish_spawn_egg", Res.drawable.silverfish_spawn_egg)
  map.put("skeleton_horse_spawn_egg", Res.drawable.skeleton_horse_spawn_egg)
  map.put("skeleton_skull", Res.drawable.skeleton_skull)
  map.put("skeleton_spawn_egg", Res.drawable.skeleton_spawn_egg)
  map.put("skull_banner_pattern", Res.drawable.skull_banner_pattern)
  map.put("slime_ball", Res.drawable.slime_ball)
  map.put("slime_block", Res.drawable.slime_block)
  map.put("slime_spawn_egg", Res.drawable.slime_spawn_egg)
  map.put("smithing_table", Res.drawable.smithing_table)
  map.put("smoker", Res.drawable.smoker)
  map.put("smooth_quartz", Res.drawable.smooth_quartz)
  map.put("smooth_quartz_slab", Res.drawable.smooth_quartz_slab)
  map.put("smooth_quartz_stairs", Res.drawable.smooth_quartz_stairs)
  map.put("smooth_red_sandstone", Res.drawable.smooth_red_sandstone)
  map.put("smooth_red_sandstone_slab", Res.drawable.smooth_red_sandstone_slab)
  map.put("smooth_red_sandstone_stairs", Res.drawable.smooth_red_sandstone_stairs)
  map.put("smooth_sandstone", Res.drawable.smooth_sandstone)
  map.put("smooth_sandstone_slab", Res.drawable.smooth_sandstone_slab)
  map.put("smooth_sandstone_stairs", Res.drawable.smooth_sandstone_stairs)
  map.put("smooth_stone", Res.drawable.smooth_stone)
  map.put("smooth_stone_slab", Res.drawable.smooth_stone_slab)
  map.put("snow", Res.drawable.snow)
  map.put("snow_block", Res.drawable.snow_block)
  map.put("snowball", Res.drawable.snowball)
  map.put("soul_campfire", Res.drawable.soul_campfire)
  map.put("soul_lantern", Res.drawable.soul_lantern)
  map.put("soul_sand", Res.drawable.soul_sand)
  map.put("soul_soil", Res.drawable.soul_soil)
  map.put("soul_torch", Res.drawable.soul_torch)
  map.put("spawner", Res.drawable.spawner)
  map.put("spectral_arrow", Res.drawable.spectral_arrow)
  map.put("spider_eye", Res.drawable.spider_eye)
  map.put("spider_spawn_egg", Res.drawable.spider_spawn_egg)
  map.put("splash_fire_res", Res.drawable.splash_fire_res)
  map.put("splash_potion", Res.drawable.splash_potion)
  map.put("sponge", Res.drawable.sponge)
  map.put("spruce_boat", Res.drawable.spruce_boat)
  map.put("spruce_button", Res.drawable.spruce_button)
  map.put("spruce_door", Res.drawable.spruce_door)
  map.put("spruce_fence", Res.drawable.spruce_fence)
  map.put("spruce_fence_gate", Res.drawable.spruce_fence_gate)
  map.put("spruce_leaves", Res.drawable.spruce_leaves)
  map.put("spruce_log", Res.drawable.spruce_log)
  map.put("spruce_planks", Res.drawable.spruce_planks)
  map.put("spruce_pressure_plate", Res.drawable.spruce_pressure_plate)
  map.put("spruce_sapling", Res.drawable.spruce_sapling)
  map.put("spruce_sign", Res.drawable.spruce_sign)
  map.put("spruce_slab", Res.drawable.spruce_slab)
  map.put("spruce_stairs", Res.drawable.spruce_stairs)
  map.put("spruce_trapdoor", Res.drawable.spruce_trapdoor)
  map.put("spruce_wood", Res.drawable.spruce_wood)
  map.put("squid_spawn_egg", Res.drawable.squid_spawn_egg)
  map.put("stick", Res.drawable.stick)
  map.put("sticky_piston", Res.drawable.sticky_piston)
  map.put("stone", Res.drawable.stone)
  map.put("stone_axe", Res.drawable.stone_axe)
  map.put("stone_brick_slab", Res.drawable.stone_brick_slab)
  map.put("stone_brick_stairs", Res.drawable.stone_brick_stairs)
  map.put("stone_brick_wall", Res.drawable.stone_brick_wall)
  map.put("stone_bricks", Res.drawable.stone_bricks)
  map.put("stone_button", Res.drawable.stone_button)
  map.put("stone_hoe", Res.drawable.stone_hoe)
  map.put("stone_pickaxe", Res.drawable.stone_pickaxe)
  map.put("stone_pressure_plate", Res.drawable.stone_pressure_plate)
  map.put("stone_shovel", Res.drawable.stone_shovel)
  map.put("stone_slab", Res.drawable.stone_slab)
  map.put("stone_stairs", Res.drawable.stone_stairs)
  map.put("stone_sword", Res.drawable.stone_sword)
  map.put("stonecutter", Res.drawable.stonecutter)
  map.put("stray_spawn_egg", Res.drawable.stray_spawn_egg)
  map.put("strider_spawn_egg", Res.drawable.strider_spawn_egg)
  map.put("string", Res.drawable.string)
  map.put("stripped_acacia_log", Res.drawable.stripped_acacia_log)
  map.put("stripped_acacia_wood", Res.drawable.stripped_acacia_wood)
  map.put("stripped_birch_log", Res.drawable.stripped_birch_log)
  map.put("stripped_birch_wood", Res.drawable.stripped_birch_wood)
  map.put("stripped_crimson_hyphae", Res.drawable.stripped_crimson_hyphae)
  map.put("stripped_crimson_stem", Res.drawable.stripped_crimson_stem)
  map.put("stripped_dark_oak_log", Res.drawable.stripped_dark_oak_log)
  map.put("stripped_dark_oak_wood", Res.drawable.stripped_dark_oak_wood)
  map.put("stripped_jungle_log", Res.drawable.stripped_jungle_log)
  map.put("stripped_jungle_wood", Res.drawable.stripped_jungle_wood)
  map.put("stripped_oak_log", Res.drawable.stripped_oak_log)
  map.put("stripped_oak_wood", Res.drawable.stripped_oak_wood)
  map.put("stripped_spruce_log", Res.drawable.stripped_spruce_log)
  map.put("stripped_spruce_wood", Res.drawable.stripped_spruce_wood)
  map.put("stripped_warped_hyphae", Res.drawable.stripped_warped_hyphae)
  map.put("stripped_warped_stem", Res.drawable.stripped_warped_stem)
  map.put("structure_block", Res.drawable.structure_block)
  map.put("structure_void", Res.drawable.structure_void)
}
